import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetBannedPlayerTableData } from '@/modules/manage-player/type'
import BannedPlayerTable from '../BannedPlayerTable'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

interface BannedPlayerListingProps {
	data: GetBannedPlayerTableData[]
	total: number
	isLoading?: boolean
}

export default function BannedPlayerListing({
	data,
	total,
	isLoading,
}: BannedPlayerListingProps) {
	return (
		<div className="space-y-4 sm:space-y-6">
			{/* Title and Date Controls Row */}
			<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
				<Heading
					title={`ผู้ใช้งานถูกแบน`}
					description={`รายการผู้ใช้งานถูกแบนทั้งหมด ${total} รายการ`}
				/>

				{/* Date Controls */}
				<div className="flex flex-col gap-3 sm:items-end">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator />
			<BannedPlayerTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
